import React, { useState } from "react";
import { Grid, useMediaQuery } from "@mui/material";
import { Button, FunctionField, Labeled, ReferenceField, SelectField, SimpleShowLayout, TextField } from "react-admin";
import { settings } from "app";
import { administrationRequests } from "api/administrationApi";
import { StateExamAssignmentTypeChoices, StateExamTypeChoices } from "utils/choices";
import SecuredComponent from "server/security/SecuredComponent";
import permissions from "app/permissions";
import EditIcon from "@mui/icons-material/Edit";
import StudyGroupsEditForm from "./StudyGroupsEditForm";
import { StateExamAssignmentType } from "utils/constants";
import { InternshipSessionField } from "server/components/Fields/InternshipSessionInput";
import { SectionTitle } from "features/SectionTitle";

const StateExamGeneralInfo = ({ record }) => {
  const isMobile = useMediaQuery(theme => theme.breakpoints.down("md"));
  const [isStudyGroupsEditing, setIsStudyGroupsEditing] = useState(false);

  const handleStudyGroupsEditClick = () => {
    setIsStudyGroupsEditing(true);
  };

  return (
    <>
      <SectionTitle
        title="Информация"
        textAlign="center"
        sx={{ marginTop: "2rem" }}
      />
      <SimpleShowLayout>
        <Grid
          container
          spacing={3}
          sx={isMobile ? settings.style.shadowBoxMobile : settings.style.shadowBox}
        >
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Сесиен стаж">
              <InternshipSessionField />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Държавен изпит">
              <ReferenceField
                source="stateExamId"
                reference={administrationRequests.getStateExamsSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Тип">
              <SelectField
                source="type"
                choices={StateExamTypeChoices}
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Тип назначение">
              <SelectField
                source="assignmentType"
                choices={StateExamAssignmentTypeChoices}
                optionText={rec => rec.name}
              />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Специалност">
              <ReferenceField
                source="specialityId"
                reference={administrationRequests.getSpecialitiesSelect()}
              >
                <TextField source="name" />
              </ReferenceField>
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Дата на създаване">
              <FunctionField render={rec => new Date(rec.createdOn).toLocaleString("bg-BG")} />
            </Labeled>
          </Grid>
          <Grid
            item
            xs={12}
            md={3}
          >
            <Labeled label="Дата на промяна">
              <FunctionField render={rec => new Date(rec.updatedOn).toLocaleString("bg-BG")} />
            </Labeled>
          </Grid>
          {isStudyGroupsEditing ? (
            <StudyGroupsEditForm
              setIsStudyGroupsEditing={setIsStudyGroupsEditing}
              record={record}
            />
          ) : (
            <>
              <Grid
                item
                xs={12}
                md={3}
              >
                <Labeled label="Учебни групи">
                  <FunctionField render={rec => (rec?.studyGroups?.length ? rec?.studyGroups.join(", ") : "-")} />
                </Labeled>
              </Grid>
              {record?.assignmentType === StateExamAssignmentType.ForStudyGroups && (
                <SecuredComponent permission={permissions.canManageStateExamStudyGroups}>
                  <Button
                    variant="contained"
                    startIcon={<EditIcon />}
                    label="Редактирай"
                    onClick={handleStudyGroupsEditClick}
                    sx={{ mt: 1, ml: 2 }}
                  />
                </SecuredComponent>
              )}
            </>
          )}
        </Grid>
      </SimpleShowLayout>
    </>
  );
};

export default StateExamGeneralInfo;
